import { resolveProp } from '@clearscore/helpers.resolve-props';

export default (state) => resolveProp('profile.data.2faEnabled', state);
